import(/* webpackMode: "eager", webpackExports: ["Contacts"] */ "/vercel/path0/modules/contacts/Contacts.tsx");
